import React, { useEffect, useState } from "react";
import AddDestination from "./AddDestination";
import { getAdminUserList } from "../../services/super-admin.service";
import AddIcon from "../../assets/images/add_icon.svg";
import toast from "react-hot-toast";
import PaginatedTable from "../common/PaginatedTable";
import EditIcon from "../../assets/images/edit_icon.svg";
import ViewIcon from "../../assets/images/view_icon.svg";
import DeleteIcon from "../../assets/images/delete_icon.svg";
import { getDestination } from "../../services/Destination.service";
import { useNavigate } from "react-router-dom";

const DestinationList = () => {
  const navigate = useNavigate();
  const [list, setList] = useState([]);
  const [showCreate, setShowCreate] = useState(false);
  const [showTable, setShowTable] = useState(true);

  //Paginated Table Variables
  let [totalCount, setTotalCount] = useState(0);
  let [currentPage, setCurrentPage] = useState(1);
  let [itemsPerPage, setItemsPerPage] = useState(10);
  let [searchKey, setSearchKey] = useState("");
  let [isLoading, setIsLoading] = useState(true);
  const [maxPageNumberLimit, setMaxPageNumberLimit] = useState(5);
  const [minPageNumberLimit, setMinPageNumberLimit] = useState(0);
  const [activePopup, setActivePopup] = useState(null);

  const handleShowCreate = () => {
    setShowCreate(true);
    setShowTable(false);
  };

  const back = (cond = true) => {
    cond && destinationList();
    setShowCreate(false);
    setShowTable(true);
  };

  useEffect(() => {
    destinationList();
  }, [currentPage, itemsPerPage, searchKey ,setSearchKey]);

  const [column, setColumn] = useState([
    
    {
      heading: () => "Name",
      cell: (row) => (row["name"] ? row["name"] : "-"),
      hidden: false,
      width: "120",
      align: "left",
      id: 1,
    },
    {
      heading: () => "ShortName",
      cell: (row) => (row["shortName"] ? row["shortName"] : "-"),
      hidden: false,
      width: "120",
      align: "left",
      id: 2,
    },

    {
      heading: () => "Active",
      cell: (row) => (
        <span  className={row?.active ? "fontWeight600 UFOGreen_text" : "fontWeight600 errorClr_text"}>
          {row["active"] ? "Active" : "Inactive"}
        </span>
      ),
      hidden: false,
      width: "120",
      align: "left",
      id: 3,
    },
    {
      heading: () => "Action",
      cell: (row) => (
        <>
          <div>
          {/* <img className="CyanSky_filter" src={ViewIcon} alt="View" />
          <img className="CyanSky_filter" src={EditIcon} alt="Edit" />
          <img className="CyanSky_filter" src={DeleteIcon} alt="Delete" /> */}
          <button   onClick={() => navigate(`/admin/destination-management/edit/${row?.id}`)}  >
            <img className="CyanSky_filter" src={EditIcon} alt="Edit" />
            </button>
            {/* <button  onClick={() => setActivePopup({ action: "delete", data: {row} })} >
            <img className="CyanSky_filter" src={DeleteIcon} alt="Delete" onClick={() => setActivePopup({ action: "delete", data: {row} })} />
            </button> */}
          </div>
        </>
      ),

      hidden: false,
      // width: "120",
      // align: "center",
      id: 1,
    },
  ]);

  const destinationList = async () => {
    const offset = (currentPage - 1) * itemsPerPage;
    const offsetToUse = offset >= 0 ? offset : 0;

    try {
      const requestBody = {
        offset: offsetToUse,
        limit: itemsPerPage,
        search: searchKey,
      };
      let res = await getDestination('E');

      if (res?.status === 200) {
               
        if (res?.data) {
          setList(res?.data);
          setTotalCount(res?.data.length);
        }
      } else {
        toast.error(res?.message || res?.data?.message);
      }

    } catch (error) {
      if (error?.message) {
        const msg = error?.message?.split(":")?.[1]?.trim();
        console.error(msg);
        // alert(msg);
      }
      console.log(error.message);
    }
  };

  return (
    <div>
      {showTable && (
        <div>
          <div className="mb_24 displayFlex alignItem_center justifyContent_spacebetween">
            <div>
              <h5 className="fontSize20 fontWeight600 blackClr_text">
                {" "}
                Destination List 
              </h5>
            </div>
            <div>
              <button
                className="MainButton cyanSky_clr gap8"
                type="button"
                onClick={handleShowCreate}
              >
                <img className="width20px" src={AddIcon} alt="AddIcon" />
                <span> Add Destination </span>
              </button>
            </div>
          </div>

          {isLoading ? (
            <PaginatedTable
              row={list}
              column={column}
              totalCount={totalCount}
              itemsPerPage={itemsPerPage}
              setItemsPerPage={setItemsPerPage}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              isSearch={true}
              searchKey={searchKey}
              setSearchKey={setSearchKey}
              maxPageNumberLimit={maxPageNumberLimit}
              setMaxPageNumberLimit={setMaxPageNumberLimit}
              minPageNumberLimit={minPageNumberLimit}
              setMinPageNumberLimit={setMinPageNumberLimit}
              //   setRange={setRange}
              //   range={range}
              isExport={false}
              isDateRange={false}
              //   handleExport={() => handleExportTransactions()}
            />
          ) : (
            <div style={{ textAlign: "center" }}>Loading...</div>
          )}
        </div>
      )}

      {showCreate && <AddDestination back={back} />}
    </div>
  );
};

export default DestinationList;
